import React, { useEffect, useState } from "react";
import {
    FaUsers,
    FaCheckCircle,
} from "react-icons/fa";
import { MdOutlineChevronRight } from "react-icons/md";
import tw from "tailwind-styled-components";

function SummaryCards({ summaryData, onClick, setSelectedId, selectedId }) {

    const summary = [
        {
            amount: summaryData?.total || 0,
            label: `Total`,
            icon: <FaUsers size={18} />,
            filter: 'total',
        },
        {
            amount: summaryData?.active || 0,
            label: `Active`,
            icon: <FaUsers size={18} />,
            filter: 'Inquiry',
        },
        {
            amount: summaryData?.closed || 0,
            label: `Closed Won`,
            icon: <FaCheckCircle size={18} />,
            filter: 'Closed',
        },
        // {
        //     amount: summaryData?.lost || 0,
        //     label: `Lost / Cancelled`,
        //     icon: <FaTimesCircle size={18} />,
        //     filter: 'Lost',
        // },
    ];

    return (
        <Wrapper>
            <ScrollCard style={{
                scrollBehavior: "smooth",
            }}>
                {summary.map((item, index) => (
                    <Card
                        $selected={selectedId === index}
                        key={index}
                    // onClick={() => {
                    //     setSelectedId(index);
                    //     onClick(item.filter);
                    // }}
                    >
                        <ValueRow>
                            <Value $color={item.color}>{item.amount}</Value>
                        </ValueRow>
                        <Label>
                            {item.label}
                            {/* <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap> */}
                        </Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-2xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;